import React, { useEffect } from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { FactStrip } from './components/FactStrip';
import { Problems } from './components/Problems';
import { CollectionIntro } from './components/CollectionIntro';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { TeachingProcess } from './components/TeachingProcess';
import { Offer } from './components/Offer';
import { UseCases } from './components/UseCases';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyMobileCta } from './components/StickyMobileCta';
import { siteConfig } from './data/siteConfig';
import { setPageMeta } from './utils/seo';
import { initMetaPixel } from './utils/metaPixel';
type AppProps = {
  showStickyMobileCta?: boolean;
};
export function App({
  showStickyMobileCta = true
}: AppProps) {
  useEffect(() => {
    setPageMeta(siteConfig.seo.title, siteConfig.seo.description);
    initMetaPixel();
  }, []);
  return <div className="w-full overflow-x-hidden bg-ivory font-sans text-charcoal" data-id="element-0" data-mp="3mjq2zht18ww4">
      <TopBar data-id="element-1" data-mp="3rdkh85pvcjnt" />
      <main data-id="element-2" data-mp="3rd1a7k1rbfok">
        <Hero data-id="element-3" data-mp="3recbnd7qcbci" />
        <FactStrip data-id="element-4" data-mp="5yi8qe3h5da" />
        <Problems data-id="element-5" data-mp="6hpnd64cbd2" />
        <CollectionIntro data-id="element-6" data-mp="4wyzymxdckh" />
        <Volumes data-id="element-7" data-mp="56l3b4umzkw" />
        <Bonuses data-id="element-8" data-mp="7stfczkdj46" />
        <TeachingProcess data-id="element-9" data-mp="2zld259q0hfbj" />
        <Offer data-id="element-10" data-mp="2zm4wkh7vh708" />
        <UseCases data-id="element-11" data-mp="2zmo3z3zwcd00" />
        <Guarantee data-id="element-12" data-mp="2zn6b4vo3kbmp" />
        <Faq data-id="element-13" data-mp="33movnqc0akp0" />
        <FinalCta data-id="element-14" data-mp="33m5b01uz1i7a" />
      </main>
      <Footer data-id="element-15" data-mp="33nggc642ey0i" />
      {showStickyMobileCta && <StickyMobileCta data-id="element-16" data-mp="33oi1x4ipj2wh" />}
    </div>;
}